/**
 * Created by jiachenpan on 16/11/18.
 */

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) { // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
  }
}

// 格式化时间
export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 *get getByteLen
 * @param {Sting} val input value
 * @returns {number} output value
 */
export function getByteLen(val) {
  let len = 0
  for (let i = 0; i < val.length; i++) {
    if (val[i].match(/[^\x00-\xff]/ig) != null) {
      len += 1
    } else { len += 0.5 }
  }
  return Math.floor(len)
}

export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

export function param(json) {
  if (!json) return ''
  return cleanArray(Object.keys(json).map(key => {
    if (json[key] === undefined) return ''
    return encodeURIComponent(key) + '=' +
      encodeURIComponent(json[key])
  })).join('&')
}

export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
}

export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

export function objectMerge(target, source) {
  /* Merges two  objects,
     giving the last one precedence */

  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  Object.keys(source).forEach((property) => {
    const sourceProperty = source[property]
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty)
    } else {
      target[property] = sourceProperty
    }
  })
  return target
}

export function scrollTo(element, to, duration) {
  if (duration <= 0) return
  const difference = to - element.scrollTop
  const perTick = difference / duration * 10
  setTimeout(() => {
    element.scrollTop = element.scrollTop + perTick
    if (element.scrollTop === to) return
    scrollTo(element, to, duration - 10)
  }, 10)
}

export function toggleClass(element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

export const pickerOptions = [
  {
    text: '今天',
    onClick(picker) {
      const end = new Date()
      const start = new Date(new Date().toDateString())
      end.setTime(start.getTime())
      picker.$emit('pick', [start, end])
    }
  }, {
    text: '最近一周',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(end.getTime() - 3600 * 1000 * 24 * 7)
      picker.$emit('pick', [start, end])
    }
  }, {
    text: '最近一个月',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      picker.$emit('pick', [start, end])
    }
  }, {
    text: '最近三个月',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
      picker.$emit('pick', [start, end])
    }
  }]

export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function (...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'shallowClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach((keys) => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = source[keys].constructor === Array ? [] : {}
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

export function uniqueArr(arr) {
  return Array.from(new Set(arr))
}


export function downloadUrl(url) {
  let iframe = document.createElement('iframe')
  iframe.style.display = 'none'
  iframe.src = url
  iframe.onload = function () {
    document.body.removeChild(iframe)
  }
  document.body.appendChild(iframe)
}
export function addParamsToUrl(url, data) {
  if (typeof (url) == 'undefined' || url == null || url == '') {
    return '';
  }
  if (typeof (data) == 'undefined' || data == null || typeof (data) != 'object') {
    return '';
  }
  url += (url.indexOf("?") != -1) ? "" : "?";
  for (var k in data) {
    url += ((url.indexOf("=") != -1) ? "&" : "") + k + "=" + encodeURI(data[k]);
    // url);
  }
  return url;
}

//数组合计
// 第一个参数是要求和的数组对象，后面是要求和的字段（不定项），如果要求和的字段值是字符串也做了相应转换
export function array_obj_field_sum(arr, ...param) {
  var temp = {};
  arr.forEach(function (item, index) {
    for (var k in item) {
      if (param.indexOf(k) >= 0) {
        if ((typeof item[k]) == 'string') {
          item[k] = item[k] * 1
        }
        if (temp[k]) {
          temp[k] += item[k];
        } else {
          temp[k] = item[k];
        }
      }
    }
  });
  return temp;
};
//数组筛选
// 第一个参数是要筛选的数据，第二个参数是筛选值，后面是筛选的字段
export function obj_filter(data, v, ...k) {
  let key = (v || '').trim();
  let keyLength = key.length;
  let keyMatcher = new RegExp(key, 'i');
  if (keyLength) {
    data = data.filter(res => {
      let flag = false;
      for (var item of k) {
        flag = keyMatcher.test(res[item]);
        if (flag) break;
      }
      return flag;
    })
  }
  return data;
}
//数组多重排序
// 前两个参数是sort方法的两个参数，第三个参数可有可无，为排序属性，即要排序的字段和排序的方向；如果第三个字段为空，则按照全属性升序排序
export function obj_sort(item1, item2) {
  // "use strict";
  var props = [];
  for (var _i = 2; _i < arguments.length; _i++) {
    props[_i - 2] = arguments[_i];
  }
  var cps = []; // 存储排序属性比较结果。
  // 如果未指定排序属性，则按照全属性升序排序。
  var asc = true;
  if (props.length < 1) {
    for (var p in item1) {
      if (item1[p] > item2[p]) {
        cps.push(1);
        break; // 大于时跳出循环。
      } else if (item1[p] === item2[p]) {
        cps.push(0);
      } else {
        cps.push(-1);
        break; // 小于时跳出循环。
      }
    }
  }
  else {
    for (var i = 0; i < props.length; i++) {
      var prop = props[i];
      for (var o in prop) {
        asc = prop[o] === "ascending" ? 1 : -1;
        if (item1[o] > item2[o]) {
          return asc;
        } else if (item1[o] < item2[o]) {
          return -asc;
        }
      }
    }
    return 0;
  }
  for (var j = 0; j < cps.length; j++) {
    if (cps[j] === 1 || cps[j] === -1) {
      return cps[j];
    }
  }

  return false;
};

//将列表中某些逗号分隔的字符串字段值转为数组类型
export function strfieldToArrayField(listData, fieldsArray) {
  for (let i = 0; i < listData.length; i++) {
    for (let j = 0; j < fieldsArray.length; j++) {
      let v = listData[i][fieldsArray[j]]
      if (v) {
        let array = v.split(",")
        if (array && array.length > 0) {
          if (array[array.length - 1] == "")
            array.splice(array.length - 1, 1)
          listData[i][fieldsArray[j]] = array
        } else {
          listData[i][fieldsArray[j]] = []
        }
      } else {
        listData[i][fieldsArray[j]] = []
      }
    }
  }
  return listData
}
//生成 json tree 树形结构数据
export function getJsonTree(data, pIdFieldName, pIdFieldValue, fieldAliasMapObj) {
  var itemArr = [];
  for (var i = 0; i < data.length; i++) {
    var node = data[i];

    if (node[pIdFieldName] == pIdFieldValue) {

      var newNode = {};
      Object.assign(newNode, node)
      let chds = getJsonTree(data, pIdFieldName, node.id, fieldAliasMapObj);
      if (chds && chds.length > 0)
        newNode.children = chds
      Object.keys(fieldAliasMapObj).forEach(v => {
        //newNode[fieldAliasMapObj[v]] = node[v]
        newNode[v] = node[fieldAliasMapObj[v]]
      })
      itemArr.push(newNode);
    }
  }
  return itemArr;
};

//数组分组嵌套（2层或3层）
//三级分组数据一共四层
export function groupAndNest(recordsArray, fieldNameMap, group1FieldArray, group2FieldArray, group3FieldArray, sumFieldsArray) {
  var g1 = []

  for (var itm of recordsArray) {
    let r = g1.filter(i => i[group1FieldArray[0]] == itm[group1FieldArray[0]]);
    if (r.length == 0) {//第一级分组不存在
      let o = {}
      group1FieldArray.map(v => {//第1次分组
        o[v] = itm[v]
        if (fieldNameMap[v])
          o[fieldNameMap[v]] = itm[v]
      })
      if (group2FieldArray) {//第2次分组
        let d = {}
        group2FieldArray.map(v => {
          d[v] = itm[v]
          if (fieldNameMap[v])
            d[fieldNameMap[v]] = itm[v]
        })
        if (group3FieldArray) {//第3次分组
          let e = {}
          group3FieldArray.map(v => {
            e[v] = itm[v]
            if (fieldNameMap[v])
              e[fieldNameMap[v]] = itm[v]
          })
          let c = {}
          Object.keys(itm).forEach(v => {
            if (!group1FieldArray.find(e => e == v) && !group2FieldArray.find(e => e == v) && !group3FieldArray.find(e => e == v)) {
              c[v] = itm[v]
              if (fieldNameMap[v])
                c[fieldNameMap[v]] = itm[v]
            }
          })
          if (sumFieldsArray) {
            for (var sumField in sumFieldsArray) {
              sumField = sumFieldsArray[sumField]
              e[sumField] = c[sumField]
              d[sumField] = c[sumField]
              o[sumField] = c[sumField]
            }
          }
          e.children = [c]
          d.children = [e]
          o.children = [d]
        } else {//仅2次分组
          let c = {}
          Object.keys(itm).forEach(v => {
            if (!group1FieldArray.find(e => e == v) && !group2FieldArray.find(e => e == v)) {
              c[v] = itm[v]
              if (fieldNameMap[v])
                c[fieldNameMap[v]] = itm[v]
            }
          })
          if (sumFieldsArray) {
            for (var sumField in sumFieldsArray) {
              sumField = sumFieldsArray[sumField]
              d[sumField] = c[sumField]
              o[sumField] = c[sumField]
            }
          }
          d.children = [c]
          o.children = [d]
        }
      } else {//仅1次分组
        let c = {}
        Object.keys(itm).forEach(v => {
          if (!group1FieldArray.find(e => e == v)) {
            c[v] = itm[v]
            if (fieldNameMap[v])
              c[fieldNameMap[v]] = itm[v]
          }
        })
        if (sumFieldsArray) {
          for (var sumField in sumFieldsArray) {
            sumField = sumFieldsArray[sumField]
            o[sumField] = c[sumField]
          }
        }
        o.children = [c]
      }

      g1.push(o)

    } else {//第一级分组已存在
      if (group2FieldArray) {//第2次分组
        let r2 = r[0].children.filter(i => i[group2FieldArray[0]] == itm[group2FieldArray[0]]);
        if (r2.length == 0) {//第二级分组不存在
          let d = {}
          group2FieldArray.map(v => {
            d[v] = itm[v]
            if (fieldNameMap[v])
              d[fieldNameMap[v]] = itm[v]
          })

          if (group3FieldArray) {//第3次分组
            let e = {}
            group3FieldArray.map(v => {
              e[v] = itm[v]
              if (fieldNameMap[v])
                e[fieldNameMap[v]] = itm[v]
            })
            let c = {}
            Object.keys(itm).forEach(v => {
              if (!group1FieldArray.find(e => e == v)) {
                c[v] = itm[v]
                if (fieldNameMap[v])
                  c[fieldNameMap[v]] = itm[v]
              }
            })
            if (sumFieldsArray) {
              for (var sumField in sumFieldsArray) {
                sumField = sumFieldsArray[sumField]
                if (!e[sumField]) e[sumField] = 0
                e[sumField] = e[sumField] + c[sumField]
                if (!d[sumField]) d[sumField] = 0
                d[sumField] = d[sumField] + c[sumField]
                r[0][sumField] = r[0][sumField] + c[sumField]
              }
            }
            e.children = [c]
            d.children = [e]
            r[0].children.push(d)
          } else {//仅2次分组
            let c = {}
            Object.keys(itm).forEach(v => {
              if (!group1FieldArray.find(e => e == v)) {
                c[v] = itm[v]
                if (fieldNameMap[v])
                  c[fieldNameMap[v]] = itm[v]
              }
            })
            if (sumFieldsArray) {
              for (var sumField in sumFieldsArray) {
                sumField = sumFieldsArray[sumField]
                if (!d[sumField]) d[sumField] = 0
                d[sumField] = d[sumField] + c[sumField]
                r[0][sumField] = r[0][sumField] + c[sumField]
              }
            }
            d.children = [c]
            r[0].children.push(d)
          }

        } else {//第二级分组已存在
          if (group3FieldArray) {//第3次分组
            let r3 = r2[0].children.filter(i => i[group3FieldArray[0]] == itm[group3FieldArray[0]]);
            if (r3.length == 0) {//第三级分组不存在
              let e = {}
              group3FieldArray.map(v => {
                e[v] = itm[v]
                if (fieldNameMap[v])
                  e[fieldNameMap[v]] = itm[v]
              })
              let c = {}
              Object.keys(itm).forEach(v => {
                if (!group1FieldArray.find(e => e == v) && !group2FieldArray.find(e => e == v) && !group3FieldArray.find(e => e == v)) {
                  c[v] = itm[v]
                  if (fieldNameMap[v])
                    c[fieldNameMap[v]] = itm[v]
                }
              })
              if (sumFieldsArray) {
                for (var sumField in sumFieldsArray) {
                  sumField = sumFieldsArray[sumField]
                  if (!e[sumField]) e[sumField] = 0
                  e[sumField] = e[sumField] + c[sumField]
                  r2[0][sumField] = r2[0][sumField] + c[sumField]
                  r[0][sumField] = r[0][sumField] + c[sumField]
                }
              }
              e.children = [c]
              r2[0].children.push(e)
            } else {//第三级分组已存在
              let c = {}
              Object.keys(itm).forEach(v => {
                if (!group1FieldArray.find(e => e == v) && !group2FieldArray.find(e => e == v) && !group3FieldArray.find(e => e == v)) {
                  c[v] = itm[v]
                  if (fieldNameMap[v])
                    c[fieldNameMap[v]] = itm[v]
                }
              })
              if (sumFieldsArray) {
                for (var sumField in sumFieldsArray) {
                  sumField = sumFieldsArray[sumField]
                  r3[0][sumField] = r3[0][sumField] + c[sumField]
                  r2[0][sumField] = r2[0][sumField] + c[sumField]
                  r[0][sumField] = r[0][sumField] + c[sumField]
                }
              }
              r3[0].children.push(c)
            }
          } else {//仅2次分组
            let c = {}
            Object.keys(itm).forEach(v => {
              if (!group1FieldArray.find(e => e == v) && !group2FieldArray.find(e => e == v)) {
                c[v] = itm[v]
                if (fieldNameMap[v])
                  c[fieldNameMap[v]] = itm[v]
              }
            })
            if (sumFieldsArray) {
              for (var sumField in sumFieldsArray) {
                sumField = sumFieldsArray[sumField]
                r2[0][sumField] = r2[0][sumField] + c[sumField]
                r[0][sumField] = r[0][sumField] + c[sumField]
              }
            }
            r2[0].children.push(c)
          }
        }
      } else {//仅1次分组
        let c = {}
        Object.keys(itm).forEach(v => {
          if (!group1FieldArray.find(e => e == v)) {
            c[v] = itm[v]
            if (fieldNameMap[v])
              c[fieldNameMap[v]] = itm[v]
          }
        })
        if (sumFieldsArray) {
          for (var sumField in sumFieldsArray) {
            sumField = sumFieldsArray[sumField]
            r[0][sumField] = r[0][sumField] + c[sumField]
          }
        }
        r[0].children.push(c)
      }
    }
  }
  //// g1)
  return g1
};


// WEBPACK FOOTER //
// ./src/utils/index.js